import axios from '@/api/axios';

const SESSION_URL = '/sessions';

export default {
  authenticate(data) {
    return axios.post(SESSION_URL, data);
  },
};
